import { useState } from 'react'
import styles from './BatteryDead.module.css'
import { BatteryEmpty } from 'phosphor-react'

type Props = {
  onChargingComplete: () => void
}

export default function BatteryDead({ onChargingComplete }: Props) {
  const [isCharging, setIsCharging] = useState(false)
  const [chargeLevel, setChargeLevel] = useState(0)

  const handleClick = () => {
    if (isCharging) return
    
    setIsCharging(true)
    
    const interval = setInterval(() => {
      setChargeLevel(prev => {
        const next = prev + 2
        if (next >= 100) {
          clearInterval(interval)
          setTimeout(() => {
            onChargingComplete()
          }, 300)
          return 100
        }
        return next
      })
    }, 60)
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <div 
          className={`${styles.batteryIcon} ${isCharging ? styles.charging : ''}`}
          onClick={handleClick}
        >
          <BatteryEmpty size={120} weight="regular" />
          {isCharging && (
            <div className={styles.chargingIndicator}>
              <div 
                className={styles.chargeFill} 
                style={{ height: `${chargeLevel}%` }}
              />
            </div>
          )}
        </div>
        
        {!isCharging ? (
          <p className={styles.text}>Bateria esgotada</p>
        ) : (
          <p className={styles.text}>Carregando... {chargeLevel}%</p>
        )}
        
        {!isCharging && (
          <p className={styles.hint}>Clique para carregar</p>
        )}
      </div>
    </div>
  )
}
